<template>
    <footer class="footer">
        <p>Designed, Developed and Built <span class="by">by</span> <a href="https://systemico.net" target="_blank" rel="noopener noreferrer">Systemico®</a></p>
    </footer>
</template>

<script>
export default {
  name: 'footerCustom'
}
</script>
